export default __webpack_public_path__ + "static/media/Pureblood Girdle.6883d187.jpg";